import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import { mediaQueryOnly } from 'components/utils/breakpoint'
import { getInclusionIcon } from 'lib/getInclusionIcon'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const AmenitiesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: ${rem(4)};
  overflow: hidden;
  /* Only for this size make it 3 columns and 9 children for smaller and larger than the xs range we want it to be 2 columns*/
  ${mediaQueryOnly.xs} {
    grid-auto-rows: 0;
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    > *:nth-child(n+10) {
      display: none;
    }
  }
`

interface Props {
  amenities: Array<{icon: string, text: string}>
}

function SearchRentalAmenities({ amenities }: Props) {
  return (<AmenitiesGrid>
    {amenities.map((inclusion) => {
      const InclusionIcon = getInclusionIcon(inclusion.icon)
      return (
        <BodyTextBlock
            key={inclusion.text}
            format="titlecase"
            variant="medium"
            startIcon={
              <InclusionIcon data-testid={inclusion.icon} size="S" />}
          >
          {inclusion.text}
        </BodyTextBlock>
      )
    })}
  </AmenitiesGrid>)
}

export default SearchRentalAmenities
